import Icon from '../components/Icon.jsx';
import './LocationSlide.css';

export default function LocationSlide() {
  return (
    <section className="slide-content location-slide location-map-slide">
      <div className="location-map-copy reveal-stack">
        <div className="eyebrow dark">
          <Icon name="pin" />
          Location
        </div>

        <h2>Location</h2>

        <p>
          SEHA - Al Rahba Hospital is strategically positioned along the
          Abu Dhabi - Dubai corridor, offering strong accessibility and regional
          service reach.
        </p>

        <div className="location-map-facts">
          <span><b>01</b>Abu Dhabi access corridor</span>
          <span><b>02</b>Al Rahba community coverage</span>
          <span><b>03</b>Direct road-network accessibility</span>
        </div>
      </div>

      <div className="location-map-board" aria-label="Al Rahba Hospital location map">
        <div className="location-map-frame">
          <img
            src="/assets/al-rahba-google-map-v2.png"
            alt="Google map showing SEHA - Al Rahba Hospital location"
          />

          <div className="location-map-treatment" aria-hidden="true" />
          <div className="location-map-scanline" aria-hidden="true" />

          {/* Pointer aligned to the actual hospital pin on the new map */}
          <div className="location-live-pin" aria-hidden="true">
            <span />
            <i />
          </div>

          <div className="location-label-card">
            <small>Confirmed site</small>
            <strong>SEHA - Al Rahba Hospital</strong>
            <span>Al Rahba, Abu Dhabi, UAE</span>
          </div>

          <div className="location-coordinate-card">
            <small>Regional note</small>
            <b>Primary Location</b>
            <span>Updated map with pointer aligned to the actual hospital marker.</span>
          </div>
        </div>

        <div className="location-map-footer">
          <span>West · Abu Dhabi</span>
          <span>Google map reference</span>
          <span>East · Dubai corridor</span>
        </div>
      </div>
    </section>
  );
}
